import React, { Component } from 'react';
import ReportMeasure from 'customers/reports/ReportMeasure';
import autobind from 'autobind-decorator';
import { ListGroup, ListGroupItem } from 'reactstrap';
import {RiskMeasure} from 'customers/reports/RiskMeasure';
export class ReportSubCategory extends Component {
    constructor(props) {
        super(props)
        const { report } = props
        const { catalog_checkpoints: reportMeasureList, } = report
        this.state = {
            isVisible: false,
            reportMeasureList: reportMeasureList,
        };
    }

    @autobind
    toggleVisibility(event) {
        event.preventDefault();
        this.setState({
            isVisible: !this.state.isVisible
        });
    }

    @autobind
    updateMeasure(reportMeasure) {
        const { reportMeasureList } = this.state
        this.setState({
            reportMeasureList: reportMeasureList.map(
                el => el.id === reportMeasure ? reportMeasure : el
            )
        })
    }

    @autobind
    addReportMeasure(reportMeasure) {
        const { reportMeasureList } = this.state
        this.setState(
            { reportMeasureList: [...reportMeasureList, reportMeasure] }
        )
    }

    @autobind
    removeReportMeasure(reportMeasure) {
        const { reportMeasureList } = this.state
        this.setState({
            reportMeasureList: reportMeasureList.filter(
                el => el.id !== reportMeasure.id
            )
        })
    }

    @autobind
    isActive(measure) {
        const index = this.state.reportMeasureList.findIndex(
            el => el.measure === measure.id
        )
        return index > -1
    }

    render() {
        const { child } = this.props
        const report = this.props.report
        const index = this.props.index
        const isVisible = this.state.isVisible
        const checkpointList = child.checkpoints
        const measureList = []
        checkpointList.map(
            checkpoint => {
                const measures = [...checkpoint.measures]
                if (measures.length > 0) {
                    const firstMeasure = measures[0]
                    measureList.push(firstMeasure)
                    const otherMeasures = measures.slice(1)
                    otherMeasures.map(
                        measure => {
                            measureList.push(measure)
                        }
                    )
                }
            }
        )

        const display = isVisible ? 'block' : 'none';
        return (
            <ListGroupItem key={`report_category_${child.id}`}>
                <button className={'btn btn-link'} onClick={this.toggleVisibility}>
                    {index + 1}. {child.name}
                </button>
                    <ListGroup style={{display: display}}>
                        {
                            report.manual_type === 0 && measureList.map((measure, index) => (
                                <ReportMeasure
                                    measure={measure}
                                    report={report}
                                    add={this.addReportMeasure}
                                    update={this.updateMeasure}
                                    remove={this.removeReportMeasure}
                                    reportMeasureList={this.state.reportMeasureList}
                                    index={index}
                                    key={`report_measure_${index}`}
                                />
                            )
                            )
                        }
                        {
                            report.manual_type === 1 && checkpointList.map((checkpoint, index) => (
                                    <RiskMeasure
                                        measure={checkpoint}
                                        report={report}
                                        reportMeasureList={this.state.reportMeasureList}
                                        index={index}
                                        key={`report_checkpoint_${index}`}
                                    />
                                )
                            )
                        }
                    </ListGroup>
            </ListGroupItem>
        )
    }
}
